import React from 'react';
export function Footer() {
  return <footer className="bg-gray-900 text-gray-400 py-8" data-id="element-105">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-106">
        <p className="text-sm" data-id="element-107">
          © 2024 Kit Clínico Cognitivo. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}